const ESCAPED_ANCHOR_PATTERN = /&lt;\/?a\b/i

export function normalizeJatsWhitespace(value: string): string {
  return value.replace(/\s+/g, ' ').trim()
}

export function hasEscapedAnchorMarkup(value: string): boolean {
  return value.includes('&lt;') && ESCAPED_ANCHOR_PATTERN.test(value)
}

export function decodeEscapedAnchorMarkup(value: string): string {
  return value
    .replace(/&lt;(\/?)(a\b[\s\S]*?)&gt;/gi, '<$1$2>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, '\'')
    .replace(/&amp;/g, '&')
}

export function normalizeDoubleEscapedAnchorEntities(value: string): string {
  return value
    .replace(/&amp;lt;/g, '&lt;')
    .replace(/&amp;gt;/g, '&gt;')
    .replace(/&amp;quot;/g, '&quot;')
    .replace(/&amp;#39;/g, '&#39;')
}

export function mergeLabelIntoHeading(labelText: string, headingText: string): string {
  const normalizedLabel = normalizeJatsWhitespace(labelText)
  const normalizedHeading = normalizeJatsWhitespace(headingText)

  if (!normalizedLabel) {
    return normalizedHeading
  }

  if (!normalizedHeading || normalizedHeading === normalizedLabel || normalizedHeading.startsWith(`${normalizedLabel} `)) {
    return normalizedHeading
  }

  return `${normalizedLabel} ${normalizedHeading}`
}
